import axios from 'axios'

export default {
  async CheckAuthentication() {
    try {
      const response = await axios.get(`/CheckDigitalSigningAuthentication`)
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return []
      } else {
        return Promise.reject(e)
      }
    }
  },
  async getSigningUrl(params) {
    const { entityId, entityType } = params
    if (!entityId) return []

    try {
      const response = await axios.get(`GetSigningUrl/${entityId}?entityType=${entityType}`)
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return []
      } else {
        return Promise.reject(e)
      }
    }
  },
  async getSigningQrCode(params) {
    const { entityId, entityType } = params
    if (!entityId) return []

    try {
      const response = await axios.get(`GetSigningQrCode/${entityId}?entityType=${entityType}`)
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return []
      } else {
        return Promise.reject(e)
      }
    }
  },
}
